import { flushEffects } from '@crown/signal/effect';
import { flush } from './scheduler';

/**
 * A run of an effect can dirty a signal another effect reads, so the pair
 * repeats. Three passes covers the chains the components here build; each
 * further pass over an empty queue costs nothing.
 */
const PASSES = 3;

/**
 * Applies every pending effect and every batched DOM write, now.
 *
 * Both are deferred to a microtask, which is what makes a burst of writes cost
 * one pass over the DOM. An imperative API on a component whose markup is bound
 * — `activateTab`, asked for the tab it has just selected — has to hand the
 * caller the DOM it expects before returning, and cannot await anything.
 */
export function flushSync(): void {
  for (let pass = 0; pass < PASSES; pass += 1) {
    flushEffects();
    flush();
  }
}
